<script>
import { Page } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Page',
      addRoute: { name: 'Add Page' },
      verboseName: 'Podstrona',
      verboseNamePlural: 'Podstrony',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title', label: 'tytuł' },
        { prop: 'slug', label: 'slug' }
      ]
    }
  },
  computed: {
    service() {
      return Page
    }
  }
}
</script>
